import React, { Fragment } from 'react';

export function Hill(props) {
  return (
    <svg viewBox="0 0 48 48">
      <path d="M42.778 41.185L26.71 19.763a3.601 3.601 0 00-1.563-1.215V13.21H32.964a1.111 1.111 0 00.751-1.93L31.56 9.124l2.19-2.19a1.111 1.111 0 00-.786-1.897h-8.926c-.614 0-1.111.497-1.111 1.111v12.4a3.599 3.599 0 00-1.563 1.215L5.296 41.185a1.111 1.111 0 00.89 1.778h35.703a1.111 1.111 0 00.889-1.778zM25.148 7.26h5.133l-1.079 1.079a1.112 1.112 0 000 1.571l1.079 1.079h-5.133V7.259zm-2.007 13.837c.26-.346.578-.537.896-.537.318 0 .637.191.896.537l5.283 7.043-2.371 2.62-2.984-3.297a1.11 1.11 0 00-1.648 0L20.23 30.76l-2.371-2.62 5.282-7.044zM8.407 40.741l8.094-10.791 2.905 3.21a1.11 1.11 0 001.648 0l2.983-3.296 2.984 3.297a1.11 1.11 0 001.647 0l2.906-3.21 8.093 10.79H8.407z" fill="#FFF" fillRule="nonzero"/>
    </svg>
  );
}

